import ScrollableTabsButtonVisible from "@/components/tab/Tab";
import React from "react";
import CustomCard from "@/pages/travelClaims/components/CustomCard";

function MyTeam() {
  const handleButtonClick = () => {
    console.log("Button clicked");
  };
  return (
    <>
      <CustomCard
        title="My Team"
        buttonTitle="My Team"
        // handle={handleButtonClick}
      />
    </>
  );
}

export default MyTeam;
